import ReactDOM from 'react-dom/client';
import React from 'react';

import { Provider as PAGE_CONTEXT } from '../../../../contexts/PageContext';
import PAGE_COMPONENT from './SingleResource';

// eslint-disable-next-line no-undef
const props = globalPageProps || {};

ReactDOM.hydrateRoot(
    document.getElementById('root'),
    <PAGE_CONTEXT PAGE_PROPS={props.PAGE_PROPS}>
        <PAGE_COMPONENT {...props} />
    </PAGE_CONTEXT>
);

/**
 *  To render the component:
 *
 *  req.reactRender = {
 *      componentPath: 'Employer/Marketing/SingleResource/SingleResource',
 *      props: {},
 *      metaTagData:{}
 *  }
 *
 *  next();
 *  return;
 *
 */
